import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";
const messages = [];

// Define a minimal ServiceWorkerContainer interface to satisfy the type
interface MinimalServiceWorkerContainer {
  register?: (scriptURL: string, options?: any) => Promise<ServiceWorkerRegistration>;
  addEventListener?: (type: string, listener: EventListenerOrEventListenerObject, options?: any) => void;
  // Add other methods as needed (e.g., getRegistration, getRegistrations)
}

// Type assertion to modify navigator
if (!("serviceWorker" in navigator)) {
  (navigator as any).serviceWorker = {
    register: () => Promise.resolve({} as ServiceWorkerRegistration), // Mock implementation
    addEventListener: () => {}, // Mock implementation
  } as MinimalServiceWorkerContainer;
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
  },
  { passive: true },
);
if (environment?.isNgServe) {
  console.log = function (...attr) {
    messages.push(JSON.stringify(attr));
  };
  console.error = function (...attr) {
    // Map through all arguments to handle them individually
    const detailedOutput = attr.map((item) => {
      // If it's an Error object, include its stack trace or message
      if (item instanceof Error) {
        return JSON.stringify({
          message: item.message,
          stack: item.stack || "No stack trace available",
        });
      }
      // For non-error objects, try to stringify or return as-is
      try {
        return typeof item === "object" ? JSON.stringify(item) : item;
      } catch (e) {
        return String(item); // Fallback for unstringifiable objects
      }
    });
    // Push the detailed output to messages
    messages.push(detailedOutput);
  };
}
setTimeout(() => {
  const button = document.createElement("button");
  button.setAttribute("style", `width: 100%; height: 2rem; border: 0; background-color: transparent;`);
  button.addEventListener("click", function () {
    if (typeof window !== "undefined") {
      const currentHost = window.location.hostname;
      if (!currentHost.includes("pretribuna") && !currentHost.includes("localhost")) {
        window.location.href = "https://angular.pretribuna.isquad.es/";
      }
    }

    const div = document.createElement("div");
    div.innerHTML = /* HTML */ `
      <ul>
        ${messages.map((message) => /* HTML */ ` <li>${message}</li> `).join("")}
      </ul>
    `;
    document.body.appendChild(div);
  });
  document.body.appendChild(button);
}, 5000);
